      import React from 'react';
      import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./dialog";
      import { Button } from "./button";

      function ConfirmDialog({ isOpen, title, message, onConfirm, onCancel }) {
        return (
          <Dialog open={isOpen} onOpenChange={onCancel}>
            <DialogContent className="sm:max-w-md">
              <DialogTitle>{title}</DialogTitle>
              <DialogDescription className="py-4">
                {message}
              </DialogDescription>
              <div className="flex justify-end space-x-4 mt-4 pt-4 border-t">
                <Button 
                  type="button" 
                  variant="outline" 
                  onClick={onCancel}
                >
                  Cancel
                </Button>
                <Button 
                  onClick={onConfirm}
                >
                  Confirm
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        );
      }

      export default ConfirmDialog;